import React from 'react';
import { CtaButton } from './CtaButton';
import { cta, hero, heroImage, heroImageAlt } from '../data/content';
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-night" data-id="element-97" data-mp="eilex7b0aze3">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.06]" style={{
      backgroundImage: 'linear-gradient(to right, #f7f2e8 1px, transparent 1px), linear-gradient(to bottom, #f7f2e8 1px, transparent 1px)',
      backgroundSize: '72px 72px'
    }} data-id="element-98" data-mp="9lv0spiridvb" />

      <div className="relative mx-auto max-w-4xl px-4 pb-14 pt-10 text-center sm:px-6 lg:pb-20 lg:pt-16" style={{
      paddingBottom: "42px"
    }} data-id="element-99" data-mp="x9umvc54pg3k">
        <p className="font-sans text-xs font-semibold uppercase tracking-[0.18em] text-gold-soft sm:text-sm" data-id="element-100" data-mp="s9gfzxf9kc74">
          {hero.eyebrow}
        </p>

        <h1 className="mx-auto mt-4 max-w-3xl font-display text-[2rem] font-semibold leading-[1.12] tracking-tight text-parchment sm:text-5xl" data-id="element-101" data-mp="3d1a4za4glt8j">
          {hero.titleStart}{' '}
          <span className="text-gold-soft" data-id="element-102" data-mp="384s3cj4feb0f">{hero.titleHighlight}</span>
        </h1>

        <p className="mx-auto mt-5 max-w-2xl font-sans text-base leading-relaxed text-parchment/75 sm:text-lg" style={{
        fontWeight: "600"
      }} data-id="element-103" data-mp="3j6fxtot8hbdb">
          {hero.subtitle}
        </p>

        <div className="mx-auto mt-8 w-[96%] max-w-2xl sm:w-full" data-id="element-104" data-mp="39a35ovdc75ko">
          <img src={heroImage} alt={heroImageAlt} className="h-auto w-full object-contain" data-id="element-105" data-mp="3e8efx77jni3f" />
        </div>

        <p className="mx-auto mt-8 max-w-md font-sans text-sm font-semibold uppercase tracking-[0.14em] text-gold-soft" data-id="element-106" data-mp="30gzteqefgyrm">
          {hero.offerLine}
        </p>

        <div className="mx-auto mt-6 max-w-md" data-id="element-107" data-mp="2qk3lalsfyenl">
          <CtaButton size="block" href="#oferta" data-id="element-108" data-mp="2qleookhz5ke6">
            {cta.hero}
          </CtaButton>
          
        </div>
      </div>
    </header>;
}